export default function imageSizeUrl (image, size) {
  return '/storage/images/' + size + '/' + image.id + '.' + image.ext
}